import type { ApiResponse } from '../types';
import routes from '@/config/routes';
import { v3Get } from '@/api/axios.instance.V3';

const getMyEarningsById = (userId: number | null | undefined, campaignId: number | null | undefined): ApiResponse =>
  v3Get(`${routes.backendUrl.earnings.getMyEarningsById}${userId}/${campaignId}`);

export const earningsApi = {
  getMyEarningsById,
};
